module.exports = __webpack_public_path__ + "img/default-event.46876d80.png";